// packages/frontend/src/lib/next-yandex-metrica/hooks/useTrackRouteChange.ts

import { Router } from "next/router";
import { useEffect } from "react";

import { NextRouter } from "../lib/types/router";
import { ym } from "../lib/ym";

declare global {
  interface Window {
    ymab?: (...args: any[]) => void;
  }
}

export const useTrackRouteChange = ({
  tagID,
  router,
}: {
  tagID: number | null;
  router: NextRouter;
}) => {
  const getCurrentUrl = () => {
    if (typeof window === "undefined") {
      return "/";
    }

    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
  };

  // Pages router: listen to routeChangeComplete
  useEffect(() => {
    if (!tagID || router === "app") return;

    const handleRouteChange = (url: string): void => {
      ym(tagID, "hit", url);

      if (typeof window !== "undefined" && typeof window.ymab === "function") {
        window.ymab(`metrika.${tagID}`, "init");
      }
    };

    // initial page load
    if (typeof window !== "undefined" && typeof window.ymab === "function") {
      window.ymab(`metrika.${tagID}`, "init");
    }

    Router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [tagID, router]);

  // App router case (if you ever use it)
  useEffect(() => {
    if (!tagID || router === "pages") return;

    ym(tagID, "hit", getCurrentUrl());

    if (typeof window !== "undefined" && typeof window.ymab === "function") {
      window.ymab(`metrika.${tagID}`, "init");
    }
  }, [tagID, router]);
};
